import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sortBy, uniqueId } from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import { compile } from '../../../utils/search'

interface DisableOption {
  text: string
  state: boolean
  callback: (changed: boolean) => void
}

interface Props {
  categoryTitle: string
  searchPlaceholder: string
  originalList: { id: number, name: string }[]
  selectList: (string | number)[]
  callbackClick: (ele: string | number) => void
  callbackResetSelect: () => void
  keywordReset: boolean
  disableOption?: DisableOption
}

const SearchAndSelect: FC<Props> = (props) => {
  const {
    categoryTitle,
    searchPlaceholder,
    originalList,
    selectList,
    callbackClick,
    callbackResetSelect,
    keywordReset,
    disableOption,
  } = props

  const [checkboxId] = useState(() => uniqueId('checkbox_'))

  const [displayList, setDisplayList] = useState<{ id: number, name: string }[]>([])
  const [searchWord, setSearchWord] = useState<string>("")

  const searchKeyword = (words: string) => {
    setSearchWord(words)
    if (!words) {
      setDisplayList(originalList)
      return
    }
    const word = words.split(/\s+/)
    const list = originalList.filter((v) => {
      if (v === null) return false
      return (compile(word).test(v.name)) || selectList.includes(v.id)
    })
    setDisplayList(sortBy(list, 'id'))
  }

  const resetKeyword = () => {
    setSearchWord("")
    setDisplayList(originalList)
  }

  useEffect(() => {
    setDisplayList(originalList)
  }, [originalList])

  useEffect(() => {
    if (!keywordReset) resetKeyword()
  }, [keywordReset])

  return (
    <div className="category">
      <div className="category_title">
        {categoryTitle}
        {
          (selectList.length || disableOption?.state) ? (
            <div
              className="select_reset"
              role="none"
              onClick={callbackResetSelect}
            >
              リセット
            </div>
          ) : (
            <></>
          )
        }
      </div>
      {disableOption && (
        <label
          htmlFor={checkboxId}
          className="disable_option"
        >
          <input
            id={checkboxId}
            type="checkbox"
            className="icon_back"
            checked={disableOption.state}
            onChange={(e) => disableOption.callback(e.target.checked)}
          />
          <FontAwesomeIcon
            icon={['far', disableOption.state ? 'check-square' : 'square']}
            className={`icon ${disableOption.state ? 'enabled' : 'disabled'}`}
          />
          <div className="text">
            {disableOption.text}
          </div>
        </label>
      )}
      <div className={`search_area ${disableOption?.state ? 'disabled' : ''}`}>
        <FontAwesomeIcon
          icon={['fas', 'search']}
          className="icon"
        />
        <input
          type="text"
          placeholder={searchPlaceholder}
          onChange={(event) => searchKeyword(event.target.value)}
          value={searchWord}
          disabled={disableOption?.state}
        />
        {
          searchWord && !disableOption?.state && (
            <button type="button" className="reset" onClick={resetKeyword} disabled={disableOption?.state}>
              <FontAwesomeIcon icon={['far', 'times-circle']} />
            </button>
          )
        }
      </div>
      <div className="chip_list limit">
        {
          displayList.map((v) => {
            const chipClassName = [
              "chip",
              selectList.includes(v.id) ? "checked" : "",
              disableOption?.state ? "disabled" : "",
            ].join(" ")
            return (
              <button
                type="button"
                className={chipClassName}
                key={`${categoryTitle}_${v.id}`}
                onClick={() => callbackClick(v.id)}
                disabled={disableOption?.state}
              >
                {v.name}
              </button>
            )
          })
        }
        {
          !displayList.length && (
            <>
              キーワードに該当するデータはありません
            </>
          )
        }
      </div>
    </div>
  )
}

SearchAndSelect.defaultProps = {
  disableOption: undefined,
}

export default SearchAndSelect
